import type { Analytics } from 'firebase/analytics';
import { getAnalytics, logEvent } from 'firebase/analytics';
import { initializeApp } from 'firebase/app';

import { company } from '~/company/Company';
import { CompanyName } from '~/company/interface';
import { isAndroid, isIOS } from '~/utils/platform';

import type { AnalyticsProvider } from '../types';

const devConfig = {
  apiKey: 'AIzaSyDoif0NFmGqbbS-hBEGY-dt_EAwHB7OwJQ',
  authDomain: 'jiffy-ca09a.firebaseapp.com',
  projectId: 'jiffy-ca09a',
  storageBucket: 'jiffy-ca09a.firebasestorage.app',
  messagingSenderId: '17467506934',
  appId: '1:17467506934:web:d73ef6c594901f5e92ecd7',
  measurementId: 'G-9R0G2ZCQS5',
};

const prodConfigs: Partial<Record<CompanyName, Record<string, string>>> = {
  [CompanyName.CityDrinks]: {
    apiKey: 'AIzaSyCSnQTtW6MGE-_ad71dNaHeELCIZiAv-vU',
    authDomain: 'citydrinks-8316f.firebaseapp.com',
    projectId: 'citydrinks-8316f',
    storageBucket: 'citydrinks-8316f.appspot.com',
    messagingSenderId: '114787590870',
    appId: '1:114787590870:web:46fdad0e1cbbac81db1f77',
    measurementId: 'G-478QEXEMPJ',
  },
  [CompanyName.Vilo]: {
    apiKey: 'AIzaSyCedYovCeC8DlhOlYzR7HX9pprYiptUNMs',
    authDomain: 'vilo-e6f40.firebaseapp.com',
    projectId: 'vilo-e6f40',
    storageBucket: 'vilo-e6f40.firebasestorage.app',
    messagingSenderId: '459830559584',
    appId: '1:459830559584:web:57e683be5e28d94ad7d405',
    measurementId: 'G-D6FBLN9930',
  },
  [CompanyName.Okie]: {
    apiKey: 'AIzaSyDrNIFi8WncCLlGXm7JgsT1o5MjADfsPko',
    authDomain: 'jamnow-54ca6.firebaseapp.com',
    projectId: 'jamnow-54ca6',
    storageBucket: 'jamnow-54ca6.firebasestorage.app',
    messagingSenderId: '342606352808',
    appId: '1:342606352808:web:500f3b742dea182423cd9d',
    measurementId: 'G-G29GB9DKFJ',
  },
  [CompanyName.Cerise]: {
    apiKey: 'AIzaSyBhQyJRKdtJqPKO3Zagiu0jPnRNkhcpv2w',
    authDomain: 'cerise-df0ab.firebaseapp.com',
    projectId: 'cerise-df0ab',
    storageBucket: 'cerise-df0ab.firebasestorage.app',
    messagingSenderId: '725794280381',
    appId: '1:725794280381:web:aad3895a9982ee9c5cf8d4',
    measurementId: 'G-76KS7XB0ZC',
  },
};

function getFirebaseConfig(): Record<string, string> | null {
  const companyConfig = prodConfigs[company.name];
  if (import.meta.env.REACT_APP_ENV === 'production') {
    return companyConfig ?? null;
  }
  return companyConfig ? devConfig : null;
}

export class FirebaseProvider implements AnalyticsProvider {
  readonly name = 'firebase' as const;
  readonly requiresConsent = true;

  private analytics: Analytics | null = null;

  isAvailable(): boolean {
    return typeof window !== 'undefined' && getFirebaseConfig() !== null;
  }

  initialize(): void {
    const config = getFirebaseConfig();
    if (!config || typeof window === 'undefined') return;
    const app = initializeApp(config);
    this.analytics = getAnalytics(app);
  }

  track(eventName: string, payload: Record<string, unknown>): void {
    if (!this.analytics) return;
    const source = isIOS() ? 'iOS' : isAndroid() ? 'android' : 'web';
    logEvent(this.analytics, eventName, { ...payload, source });
  }
}
